import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './lang/zh-CN'
import enUS from './lang/en-US'
import deDE from './lang/de-DE'
import plPL from './lang/pl-PL'

Vue.use(VueI18n)

// 从 URL 参数或 localStorage 获取语言设置
function getInitialLocale() {
  // 优先从 URL 参数获取
  const urlParams = new URLSearchParams(window.location.search)
  const urlLang = urlParams.get('language')
  
  // URL 参数映射到 i18n locale
  const urlLangMap = {
    'de': 'de-DE',
    'en': 'en-US',
    'zh': 'zh-CN',
    'bo': 'pl-PL'
  }
  
  if (urlLang && urlLangMap[urlLang]) {
    return urlLangMap[urlLang]
  }
  
  // 从 localStorage 获取
  const storedLocale = localStorage.getItem('locale')
  if (storedLocale) {
    return storedLocale
  }
  
  // 默认返回德语（根据页面内容）
  return 'de-DE'
}

const locale = getInitialLocale()

const messages = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'de-DE': deDE,
  'pl-PL': plPL
}

const i18n = new VueI18n({
  legacy: true, // Vue 2 需要使用 legacy 模式
  locale: locale,
  fallbackLocale: 'de-DE',
  messages: messages
})

// 保存语言设置到 localStorage
if (locale) {
  localStorage.setItem('locale', locale)
}

export default i18n

